import React from 'react';

const UnknownRoute = (props) => (
    <div>
        <h1>404 Unknown Page</h1>
        <div className="panel-adt">
            <p>You must gather your party before venturing forth...</p>
        </div>
    </div>
);


export default UnknownRoute;


// WEBPACK FOOTER //
// ./src/common/UnknownRoute.js